import { IRoute } from "types/shared"

import { IRoles } from "types/shared"

import Home from "components/pages/Home"
import Login from "components/pages/login"
import Dashboard from "components/pages/dashboard"
import Employee from "components/pages/employee"
import Laundry from "components/pages/laundry/Laundry"
import Reservations from "components/pages/reservations/Reservations"
import Transactions from "components/pages/transactions/Transactions"
import Settings from "components/pages/settings/Settings"
import BookingsSettings from "components/pages/settings/BookingSettings"
import CancellationFee from "components/pages/settings/CancellationFee"
import Clients from "components/pages/clients/Clients"
import Loundries from "components/pages/loundries"
import ChangeHistory from "components/pages/changeHistory"
import BookingFee from "components/pages/settings/BookingFee"
import Customers from "components/pages/customers"
import ExtractReports from "components/pages/extractReports"
import LanguageSettings from "components/pages/languageSettings"
import Districts from "components/pages/districts"

export const ROUTES: IRoute[] = [
  {
    path: "/login",
    element: <Login />,
    isPrivate: false,
    allowedRoles: [
      IRoles.QAPP_ADMIN,
      IRoles.WASHER_ADMIN,
      IRoles.QAPP_MANAGER,
    ],
  },
  {
    path: "/",
    element: <Home />,
    isPrivate: true,
    allowedRoles: [
      IRoles.QAPP_ADMIN,
      IRoles.QAPP_MANAGER,
      IRoles.WASHER_ADMIN,
      IRoles.QAPP_MANAGER,
    ],
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
    isPrivate: true,
    allowedRoles: [
      IRoles.QAPP_ADMIN,
      IRoles.WASHER_ADMIN,
      IRoles.QAPP_MANAGER,
    ],
  },

  {
    path: "/customers",
    element: <Customers />,
    isPrivate: true,
    allowedRoles: [
      IRoles.QAPP_ADMIN,
      IRoles.QAPP_MANAGER
    ],
  },
  {
    path: "/laundries",
    element: <Loundries />,
    isPrivate: true,
    allowedRoles: [
      IRoles.QAPP_ADMIN,
      IRoles.QAPP_MANAGER,
    ],
  },
  {
    path: "/employees",
    element: <Employee />,
    isPrivate: true,
    allowedRoles: [
      IRoles.QAPP_ADMIN,
      IRoles.WASHER_ADMIN
    ],
  },
  {
    path: "/reservations",
    element: <Reservations />,
    isPrivate: true,
    allowedRoles: [
      IRoles.QAPP_ADMIN,
      IRoles.QAPP_MANAGER,
      IRoles.WASHER_ADMIN,
      IRoles.WASHER_MANAGER,
      IRoles.CASHIER
    ],
  },
  {
    path: "/laundry",
    element: <Laundry />,
    isPrivate: true,
    allowedRoles: [
      IRoles.QAPP_ADMIN,
      IRoles.QAPP_MANAGER,
    ],
  },
  {
    path: "/laundries/:laundryId",
    element: <Laundry />,
    isPrivate: true,
    allowedRoles: [
      IRoles.QAPP_ADMIN,
      IRoles.QAPP_MANAGER,
      IRoles.WASHER_ADMIN,
    ],
  },
  {
    path: "/add-laundry",
    element: <Laundry />,
    isPrivate: true,
    allowedRoles: [IRoles.QAPP_ADMIN],
  },
  {
    path: "/laundry/:laundryId/change_history",
    element: <ChangeHistory />,
    isPrivate: true,
    allowedRoles: [
      IRoles.QAPP_ADMIN,
      IRoles.WASHER_ADMIN,
      IRoles.QAPP_MANAGER,
    ],
  },
  {
    path: "/transactions",
    element: <Transactions />,
    isPrivate: true,
    allowedRoles: [
      IRoles.QAPP_ADMIN,
      IRoles.QAPP_MANAGER,
      IRoles.WASHER_ADMIN,
    ],
  },
  {
    path: "/reports",
    element: <ExtractReports />,
    isPrivate: true,
    allowedRoles: [
      IRoles.QAPP_ADMIN,
      IRoles.WASHER_ADMIN,
      IRoles.CASHIER
    ],
  },
  {
    path: "/settings",
    element: <Settings />,
    isPrivate: true,
    allowedRoles: [
      IRoles.QAPP_ADMIN
    ],
  },
  {
    path: "/clients",
    element: <Clients />,
    isPrivate: true,
    allowedRoles: [
      IRoles.QAPP_ADMIN
    ],
  },
  {
    path: "/settings/bookings",
    element: <BookingsSettings />,
    isPrivate: true,
    allowedRoles: [
      IRoles.QAPP_ADMIN
    ],
  },
  {
    path: "/settings/cancellation_fee",
    element: <CancellationFee />,
    isPrivate: true,
    allowedRoles: [
      IRoles.QAPP_ADMIN
    ],
  },
  {
    path: "/settings/booking_fee",
    element: <BookingFee />,
    isPrivate: true,
    allowedRoles: [
      IRoles.QAPP_ADMIN
    ],
  },
  {
    path: "/language-settings",
    element: <LanguageSettings />,
    isPrivate: true,
    allowedRoles: [
      IRoles.QAPP_ADMIN
    ],
  },
  {
    path: "/districts",
    element: <Districts />,
    isPrivate: true,
    allowedRoles: [
      IRoles.QAPP_ADMIN,
      IRoles.QAPP_MANAGER
    ],
  }
]
